import { Utils } from "helpers/utils";
import React from "react";
import UserAvatar from "./UserAvatar";

interface UserAvatarWithNameProps {
  keyValue: any;
  userId: number;
  profileImage: string;
  foreColor: string;
  backColor: string;
  abbrName: string;
  displayName2: string | null;
}
const UserAvatarWithName = ({ keyValue, userId, profileImage, foreColor, backColor, abbrName, displayName2 }: UserAvatarWithNameProps) => {

  return (
    <div key={keyValue} style={{ display: 'flex', alignItems: 'flex-start', gap: 4 }}>
      <UserAvatar
        userId={userId}
        profileImage={profileImage}
        bgColor={backColor}
        foreColor={foreColor}
        abbrName={abbrName}
        size={"xxs"}
        classMe={"me-1"}
      />
      {displayName2 && (<span>{displayName2}</span>)}
    </div>
  );
};

export default UserAvatarWithName;
